module.exports = __webpack_public_path__ + "img/symbol_4.bc9629ba.png";